import { YouTube } from 'blaze-ui/icons'
import { string, object } from 'yup'
import { FormSchema } from '../Wizard/Form/Types'
import { audience } from './shared/audience'
import { avoid } from './shared/avoid'
import { callToAction } from './shared/callToAction'
import { promotion } from './shared/promotion'
import { topic } from './shared/topic'
import { videoLength } from './shared/videoLength'
import { brandVoiceId, tone } from './shared/voiceTones'
import { safify } from './utils/safify'
import { sourceMaterialIds } from './shared/sourceMaterials'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { GenerationType } from 'components/BlazeCommandLine/api/createDocGenerationRequest'
import { brandKitId } from './shared/brandKitId'
import { language } from './shared/language'
import { TextChannels } from '../../../constants'

const meta = {
  type: ChannelType.YoutubeScript,
  title: TextChannels[ChannelType.YoutubeScript].name,
  steps: ['Context', 'Generate Script'],
  submitLabel: 'Generate Titles',
  icon: YouTube,
  previewUrl:
    'https://res.cloudinary.com/almanac/image/upload/v1710183792/Home%20Card%20Previews/yeflu46q2d5upxn1dcu3.png',
}

const fields = {
  topic: topic.meta({ label: 'What is the topic of your YouTube script?', generationType: meta.type }),
  goal: string()
    .required()
    .default('')
    .meta({
      label: 'Describe the objective of this video',
      placeholder: 'Describe the purpose and goal(s)',
      autoFill: true,
    })
    .transform(safify),
  audience: audience.meta({ label: 'Who is the target audience?' }),
  video_length: videoLength
    .required()
    .oneOf(['Less than 6 mins', '6-12 mins', 'More than 12 mins'])
    .default('6-12 mins'),
  brand_voice_id: brandVoiceId,
  brand_kit_id: brandKitId,
  source_material_ids: sourceMaterialIds,
  tone,
  language,
  promotion: promotion.meta({ collapsible: true }),
  call_to_action: callToAction.meta({ collapsible: true }),
  avoid: avoid.meta({ collapsible: true }),
}

export const YoutubeScriptSchema = object(fields).meta(meta) as FormSchema<GenerationType | ChannelType>
